export const user_minus = () => (
  <path
    d="M23 11h-6M4 21a3 3 0 110-6h9a3 3 0 110 6H4zm8.5-14a4 4 0 11-8 0 4 4 0 018 0z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
